@if (asset) {
  <div
    class="page-content"
    [class.page-content--admin-mode]="adminMode"
    [class.is-scrolling]="isScrolling"
  >
    @let header = globalDataService.config().header;
    <app-header
      [styles]="header.data.styles"
      [logoDisplay]="header.data.logo.display"
      [logoSrc]="header.data.logo.src_data"
      [logoRedirect]="header.data.logo.redirect"
      [menuItems]="header.data.menu ?? defaultHeaderMenuItems"
    ></app-header>
    <app-details-sticky-header [asset]="asset" [styles]="pageConfig().components.assetDetailsHeader.data.styles.assetDetailsHeader"></app-details-sticky-header>
    <!-- Desktop Breadcrumbs above image -->
    <app-breadcrumbs class="breadcrumbs--desktop" [asset]="asset"></app-breadcrumbs>
    <app-details-carousel [asset]="asset" [showShareButton]="pageConfig().components.shareButton.enabled" [watermarkLogo]="watermarkLogo"></app-details-carousel>
    <!-- Mobile Breadcrumbs below image -->
    <app-breadcrumbs class="breadcrumbs--mobile" [asset]="asset"></app-breadcrumbs>
    @defer {
      <div class="content">
        <app-details-information
          [asset]="asset"
          [showConfiguration]="pageConfig().components.assetInformation.data.showConfiguration"
          [showFlyerDownload]="pageConfig().components.leadForm.data.downloadFlyer"
          [showShareButton]="pageConfig().components.shareButton.enabled"
          [financeButtonEnabled]="pageConfig().components.leadForm.data.financeButtonEnabled"
        ></app-details-information>
        @let shippingBanner = pageConfig().components.shippingBanner;
        <app-shipping-banner
          [enabled]="!!shippingBanner?.enabled"
          [asset]="asset"
        ></app-shipping-banner>
        @let similarCarousel = pageConfig().components.similarCarousel;
        <app-similar-carousel
          [enabled]="!!similarCarousel?.enabled"
          [asset]="asset"
          [currencyCode]="globalData.selectedCurrency().code"
          [assetCardDefaultImage]="globalData.defaultImage()"
          [assetCardConfig]="similarCarousel?.data?.components?.assetCard"
          (cardClick)="cardClicked($event)"
          (contactClick)="contactClicked($event)"
        />
        @let recentlyViewedCarousel = pageConfig().components.recentlyViewedCarousel;
        <app-recently-viewed-carousel
          [enabled]="!!recentlyViewedCarousel?.enabled"
          [excludeAsset]="asset"
          [currencyCode]="globalData.selectedCurrency().code"
          [assetCardDefaultImage]="globalData.defaultImage()"
          [assetCardConfig]="recentlyViewedCarousel?.data?.components?.assetCard"
          (cardClick)="cardClicked($event)"
          (contactClick)="contactClicked($event)"
        />
        @let terms = globalDataService.config().legalTerms.data.terms;
        @if (terms) {
          <app-legal-terms
            [terms]="terms"
            class="detail-section terms-section"
          />
        }
        @let quickLinksBanner = pageConfig().components.quickLinksBanner;
        <app-quick-links-banner
          [enabled]="!!quickLinksBanner?.enabled"
          [containerStyles]="quickLinksBanner?.data?.styles?.quickLinksBanner"
        />
      </div>
    } @error {
      <app-error></app-error>
    }
    @let footer = globalDataService.config().footer;
    <app-footer
      [styles]="footer.data.styles"
      [address]="footer.data.address"
      [address_line_2]="footer.data.address_line_2"
      [phone]="footer.data.phone"
      [email]="footer.data.email"
      [facebook]="footer.data.facebook"
      [twitter]="footer.data.twitter"
      [instagram]="footer.data.instagram"
      [youtube]="footer.data.youtube"
      [linkedin]="footer.data.linkedin"
      [copyright_text]="footer.data.copyright_text"
      [link_1_text]="footer.data.link_1_text"
      [link_1_url]="footer.data.link_1_url"
      [link_2_text]="footer.data.link_2_text"
      [link_2_url]="footer.data.link_2_url"
      [link_3_text]="footer.data.link_3_text"
      [link_3_url]="footer.data.link_3_url"
    ></app-footer>
  </div>
}
